import { lazy } from 'react';

export const PlayerDocumentUploadForm = lazy(
  () => import('./PlayerDocumentUploadForm'),
);
